import { EdgeToEdge } from '@mindly/capacitor-android-edge-to-edge-support';
import { isPlatform } from '@ionic/react';
import { StatusBar } from '@capacitor/status-bar';

export const initSafeAreaEnvironment = async () => {
  try {
    if (isPlatform('android') && isPlatform('hybrid')) {
      await StatusBar.setOverlaysWebView({ overlay: true });
      const setInsets = async () => {
        const insets = await EdgeToEdge.getInsets();
        // need to set ion safe area variables for android
        document.documentElement.style.setProperty('--ion-safe-area-top', `${insets.top}px`);
        document.documentElement.style.setProperty('--ion-safe-area-bottom', `${insets.bottom}px`);
        document.documentElement.style.setProperty('--ion-safe-area-left', `${insets.left}px`);
        document.documentElement.style.setProperty('--ion-safe-area-right', `${insets.right}px`);

        document.documentElement.style.setProperty('--safe-area-inset-top', `${insets.top}px`);
        document.documentElement.style.setProperty('--safe-area-inset-bottom', `${insets.bottom}px`);
        document.documentElement.style.setProperty('--safe-area-inset-left', `${insets.left}px`);
        document.documentElement.style.setProperty('--safe-area-inset-right', `${insets.right}px`);
      };
      setInsets();
      // need to re-set insets on orientation change
      window.addEventListener('orientationchange', setInsets);
    }
  } catch (error) {
    console.error(error);
  }
  return Promise.resolve();
};
